import React, { useState, useCallback } from 'react';
import BarcodeReader from 'react-barcode-reader';

const BarCodeReader = () => {
    const [result, setResult] = useState('No result');

    const handleScan = useCallback((data) => {
      setResult(data); // Update result when a barcode is scanned
    }, []);
  
    const handleError = useCallback((err) => {
      console.error(err); // Handle any errors
    }, []);
  
    return (
      <div>
        <BarcodeReader
          onError={handleError}
          onScan={handleScan}
        />
        <h3>This is the scan result from the barcode scanned!</h3>
        <p>{result}</p>
      </div>
    );
}

export default BarCodeReader